import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTooltipTriangle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 5,
	height: 19,
	viewBox: "0 0 5 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_b_19967_5779)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M4.11983 18.0758C4.11983 16.3779 3.36505 14.768 2.05995 13.6821C-0.479666 11.5689 -0.70409 7.74902 1.57061 5.35301L2.28301 4.60262C3.46234 3.36039 4.11983 1.71287 4.11983 0V18.0758Z",
				fill: "currentColor"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_b_19967_5779",
			x: -43,
			y: -43,
			width: 90.1211,
			height: 104.076,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feGaussianBlur", {
					in: "BackgroundImageFix",
					stdDeviation: 21.5
				}),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "SourceAlpha",
					operator: "in",
					result: "effect1_backgroundBlur_19967_5779"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_backgroundBlur_19967_5779",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgTooltipTriangle);
export { ForwardRef as ReactComponent };
